import { render, staticRenderFns } from "./wetDetail.vue?vue&type=template&id=09d808a6&scoped=true&"
import script from "./wetDetail.vue?vue&type=script&lang=js&"
export * from "./wetDetail.vue?vue&type=script&lang=js&"
import style0 from "./wetDetail.vue?vue&type=style&index=0&id=09d808a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d808a6",
  null
  
)

export default component.exports